var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" An error occurred "+_vm._s(_vm.$route.params.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }